import React from "react";
import { Carousel } from "react-bootstrap";
import one from "../../assets/recentWork/one.jpeg";
import two from "../../assets/recentWork/two.jpeg";
import three from "../../assets/recentWork/three.jpeg";
import four from "../../assets/recentWork/four.jpeg";
import five from "../../assets/recentWork/five.jpeg";

function TrendingPComponent() {
  return (
    <div className="product-div">
      <center>
        <h1>Our Recent Work</h1>
      </center>
      <Carousel>
        <Carousel.Item className="carousel-div">
          <img className="d-block w-100" src={one} alt="First slide" />
        </Carousel.Item>
        <Carousel.Item className="carousel-div">
          <img className="d-block w-100" src={two} alt="First slide" />
        </Carousel.Item>
        <Carousel.Item className="carousel-div">
          <img className="d-block w-100" src={three} alt="First slide" />
        </Carousel.Item>
        <Carousel.Item className="carousel-div">
          <img className="d-block w-100" src={four} alt="Second slide" />
        </Carousel.Item>
        <Carousel.Item className="carousel-div">
          <img className="d-block w-100" src={five} alt="Second slide" />
        </Carousel.Item>
      </Carousel>
      <br />
    </div>
  );
}

export default TrendingPComponent;
